import { WriteBlockedKind } from '@griply/types';

// One translation key per kind, in the shared namespace (packages/assets). The Blocked fallback
// carries the generic message for kinds this client version doesn't know yet — never a remedy hint
// that might be wrong for the actual cause.
const MESSAGE_KEYS: Record<WriteBlockedKind, string> = {
  [WriteBlockedKind.Access]: 'calendar.write-blocked.access',
  [WriteBlockedKind.NotACalendar]: 'calendar.write-blocked.not-a-calendar',
  [WriteBlockedKind.Deleted]: 'calendar.write-blocked.deleted',
  [WriteBlockedKind.Blocked]: 'calendar.write-blocked.blocked',
};

export const getWriteBlockedMessageKey = (kind: WriteBlockedKind): string =>
  MESSAGE_KEYS[kind] ?? MESSAGE_KEYS[WriteBlockedKind.Blocked];
